import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../context/AuthContext';
import useHomeService from '../../services/HomeService/home.service';
import type { DashboardService } from '../../models/dashboard.model';
import HomeHeader from './HomeHeader';
import YourServices from './YourServices';
import RecentProjects from './RecentProjects';
import ServiceSummary from './ServiceSummary';
import styles from './home.module.scss';

const NO_SERVICES: DashboardService[] = [];

const Home: React.FC = () => {
  const { selectedClient } = useAuth();
  const { getDashboardServices } = useHomeService();
  const { data } = useQuery(getDashboardServices(selectedClient?.id));
  const dashboardServices = data?.services ?? NO_SERVICES;

  return (
    <div className={styles.page}>
      <HomeHeader />
      <YourServices dashboardServices={dashboardServices} />
      <RecentProjects />
      <ServiceSummary dashboardServices={dashboardServices} />
    </div>
  );
};

export default Home;
